import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        fontSize: '26px',
        color: theme.palette.black,
        fontWeight: 'bold',
        marginTop: '220px',
        [theme.breakpoints.up('lg')]: {
            marginTop: '180px',
        },
    },
    subMenuBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        height: '50px',
        width: '100%',
        top: '81px',
        zIndex: 1000,
        left: '0px',
        backgroundColor: theme.palette.primary.main,
        '& span': {
            margin: '0 10px',
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            top: '100px',
        },
        [theme.breakpoints.down('lg')]: {
            height: '100px',
        },
        position: 'fixed',
    },
    rangeDatePickerWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0px 10px 0px',
        justifyContent: 'center',
        [theme.breakpoints.up('lg')]: {
            justifyContent: 'flex-end',
        },

        [theme.breakpoints.down('md')]: {
            marginRight: theme.spacing(4),
            marginTop: '10px',
        },

        [theme.breakpoints.down('sm')]: {
            display: 'grid',
            rowGap: 10,
            justifyItems: 'center',
            flexDirection: 'column',
            marginRight: 0,
            padding: '8px 0px 10px 0px',
        },
    },
    title: {
        fontSize: '24px',
        color: theme.palette.black,
        fontWeight: 'bold',
    },
    lastUpdatedTextWrapper: {
        [theme.breakpoints.down('lg')]: {
            width: '100%',
            backgroundColor: 'hsl(197deg 62% 51%)',
        },
    },
    lastUpdatedTextWrapperContainer: {
        [theme.breakpoints.down('lg')]: {
            minWidth: '100%',
            marginTop: '10px',
        },
        [theme.breakpoints.only('xs')]: {
            marginTop: '12px',
        },
    },
    lastUpdatedText: {
        color: 'white',
        margin: '0 70px',
        padding: '8px 20px',
        border: '1px solid white',
        borderRadius: '5px',
        whiteSpace: 'nowrap',

        [theme.breakpoints.down('lg')]: {
            border: 'none',
            padding: '5px 0',
            display: 'flex',
            fontSize: '14px',
            justifyContent: 'center',
        },
    },
}));
